import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TransientNotification from './TransientNotification.component';
import "./notifications.scss";
import {Modal} from 'components/modals/Modal';
import ErrorModal from 'components/modals/Error.modal';
import {MODAL_SEVERITY} from 'utils/constants';

import translate from '../translations/translations.wrapper.jsx';
import {connect} from 'react-redux';
import {getNotifications} from '../store/application.reducers';
import {hideNotification, NOTIFICATION_TYPE} from '../notifications/notification.action';


export class NotificationsView extends Component {

    static propTypes = {
        notifications: PropTypes.object,
        hideNotification: PropTypes.func,
        translate: PropTypes.func
    };

    render() {
        const self = this;
        if (Object.keys(this.props.notifications).length === 0) {
            return null;
        } else {

            // if there is error, show the dialog, otherwise show the transient notifications
            // (we don't want to show transient notifications when we need to display error dialog)
            // from discussion with OWR, we can should show only one error dialog at the time
            let error = null;
            let out = [];
            for (let id in this.props.notifications) {
                if (this.props.notifications.hasOwnProperty(id)) {
                    const notification = this.props.notifications[id];
                    if (notification.type === NOTIFICATION_TYPE.POSITIVE_TRANSIENT) {
                        out.push(notification);
                    } else {
                        error = notification;
                        break;
                    }
                }
            }

            if (error !== null) {
                // the notification is only the envelope - the error itself is its payload
                const payload = error.data;
                const closeModal = () => this.props.hideNotification(error.id);
                return (
                    <Modal
                        open={true}
                        onClose={closeModal}
                        title={payload?.errorTitle || this.props.translate("errorPage.serverError.title")}
                        severity={MODAL_SEVERITY.DANGER}
                    >
                        {({loopFocus, initialFocusRef}) => (
                            <ErrorModal
                                more={{error: payload}}
                                closeModal={closeModal}
                                loopFocus={loopFocus}
                                initialFocusRef={initialFocusRef}
                            />
                        )}
                    </Modal>
                );
            } else {
                return (
                    <ul className={"list-unstyled notification-view"}>
                        {out.map((item) => {
                            return <TransientNotification key={item.id} data={item}
                                                          close={self.props.hideNotification}/>
                        })}
                    </ul>
                );
            }
        }
    }
}

const withTranslations = translate(NotificationsView);

const mapStateToProps = function (store) {
    return {
        notifications: getNotifications(store)
    };
};

export default connect(mapStateToProps, {
    hideNotification
})(withTranslations);